import {
  Component, OnInit, Input, ElementRef,
  Output, EventEmitter, TemplateRef, ViewContainerRef, ReflectiveInjector
} from '@angular/core';
import { Themes } from '../../models/theme/themes';
import { NotificationModel } from '../../models/notification';
import { DraggableService } from '../../services/draggable-service/draggable.service';
import { TemplateService } from '../../services/template-service/template.service';
import { Subscription } from 'rxjs/Subscription';
export class CfCoreComponent implements OnInit {
/**
 * @hidden
 */
injector = ReflectiveInjector.resolveAndCreate([DraggableService]);
/**
 * @hidden
 */
draggableService: DraggableService;
/**
 * @hidden
 */
public properties: any;
/**
 * <p>It represents an instance ID. User can set it.
 * By default, it's unique number, converted to string.</p>
 */
public id: string = CfCoreComponent.generateId();
/**
 * @hidden 
 * The name of the class that represents the component's theme
 */
public themeClass: string = Themes.default_theme;
/**
 * @hidden 
 * <p>It represents a pointer to the component's instance</p>
 */
public nativeElement: any;
/**
 * @hidden 
 * <p>It represents component tooltip</p>
 */
public tooltip: any;
/**
 * @hidden 
 * <p>Hide or Show Component</p>
 * @param {?} value
 * @return {?}
 */
set display(value: boolean) { this.properties.display = value; }
/**
 * @hidden 
 * <p>Disable or Enable Component</p>
 * @param {?} value
 * @return {?}
 */
set disable(value: boolean) { this.properties.disable = value; }
/**
 * <p>It enables component internationalization</p>
 */
public enabledI18N: boolean;
/**
 * <p>It enables component drag and drop</p>
 */
public draggable: boolean;
/**
 * @hidden 
 * <p>It is a dynamic class the user can pass for the internal button</p>
 */
public cfClass: string;
/**
 * <p>It represents core component notifications property object based on NotificationModel Class</p>
 */
public notification: NotificationModel;
/**
 * <p> It represents the user defined template passed to the component
 */
public compTemplate: string;
/**
 * @hidden
 */
activeTemplate: any;
/**
 * <p>It is core component Notifications events emmiter to be used by other components</p>
 */
notificationAction: EventEmitter<any> = new EventEmitter<any>();
/**
 * @hidden 
 * <p> Saves the tags of the events that the component is subscribed for.</p>
 * <p> Example: weather1, weather2, clock1...</p>
 */
subscriptionTags: string[] = [];
/**
 * @hidden 
 * <p>Identifier when all component properties are ready to be rendered in html</p>
 */
_inited = false;
/**
 * @hidden 
 * <p>Generate unique ID</p>
 * @return {?}
 */
static generateId(): string { return '' + Math.floor(Math.random() * 100000); }
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(public elementRef: ElementRef,
public templateService: TemplateService) {
    this.nativeElement = this.elementRef.nativeElement;
    this.draggableService = this.injector.get(DraggableService);
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    if (this.draggable) {
      this.draggableService.makeDraggable(this.id, this.elementRef.nativeElement, true);
    }
  }
/**
 * @hidden
 * @param {?} name
 * @param {?} templatesObject
 * @return {?}
 */
getMyTemplate(name: string, templatesObject) {
    let /** @type {?} */ activeTemplate = templatesObject['defaultTemplate'];
    return new Promise((resolve) => {
      this.templateService.loadTemplateJson(name, templatesObject, this.compTemplate)
        .subscribe(newTemp => {
          if (newTemp != null) {
            activeTemplate = newTemp;
          }
          this.activeTemplate = activeTemplate;
          resolve();
        },
        err => {
          this.activeTemplate = activeTemplate;
          resolve();
        })
    });
  }
/**
 * @hidden 
 * Recursive function to merge active template with properties
 * @param {?} sampler  element from active template
 * @param {?} props  element from properties
 * @param {?} name
 * @return {?}
 */
mergeGroup(sampler, props, name) {
    for (let /** @type {?} */ key in sampler) {
      if (typeof sampler[key] === 'object' && sampler[key] !== null && key !== 'template' && key !== 'item' && key !== 'items') {
        if (props == null || props[key] == null) { props[key] = sampler[key]; }
        this.mergeGroup(sampler[key], props[key], name);
      } else {
        if (props[key] == null) { props[key] = sampler[key]; }
      }
    }
  }
/**
 * @hidden 
 * Method to merge active template with properties
 * @param {?} sampler  element from active template
 * @param {?} props  element from properties
 * @param {?} name
 * @return {?}
 */
mergeProperties(sampler, props, name) {
    return new Promise((resolve) => {
      if ( props && Object.keys(props).length > 0 ) {
        this.mergeGroup(sampler, props, name);
        resolve(false);
      } else {
        resolve(true);
      }
    }).then(propsWasEmpty => {
      if (propsWasEmpty) { this.properties = sampler; }
      this._inited = true;
      return propsWasEmpty;
    });
  };
/**
 * Method to render dynamic classes for the given html element
 * @param {?} element  html element to which dynamic classes must be rendered
 * @return {?}
 */
getDynamicClasses(element) {
    if (element != null) {
      try {
        let /** @type {?} */ classes = '', /** @type {?} */ mainKeys = Object.keys(element);
        for (let /** @type {?} */ key of mainKeys) {
          // tslint:disable-next-line:no-eval
          if (eval(element[key]) === true) { classes = classes + ' ' + key; }
        }
        return classes;
      } catch ( /** @type {?} */e) {
        // Do nothing
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-core',
  template: '<div>Cedrus Fusion UI Core</div>',
  styles: ['']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'properties': [{ type: Input },],
'id': [{ type: Input },],
'themeClass': [{ type: Input },],
'tooltip': [{ type: Input },],
'display': [{ type: Input, args: ['display', ] },],
'disable': [{ type: Input, args: ['disable', ] },],
'enabledI18N': [{ type: Input },],
'draggable': [{ type: Input },],
'cfClass': [{ type: Input },],
'notification': [{ type: Input },],
'compTemplate': [{ type: Input },],
'notificationAction': [{ type: Output },],
};
}

function CfCoreComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfCoreComponent.ctorParameters;
/** @type {?} */
CfCoreComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfCoreComponent.prototype.injector;
/**
 * @hidden
 * @type {?}
 */
CfCoreComponent.prototype.draggableService;
/**
 * @hidden
 * @type {?}
 */
CfCoreComponent.prototype.properties;
/**
 * <p>It represents an instance ID. User can set it.
 * By default, it's unique number, converted to string.</p>
 * @type {?}
 */
CfCoreComponent.prototype.id;
/**
 * @hidden 
 * The name of the class that represents the component's theme
 * @type {?}
 */
CfCoreComponent.prototype.themeClass;
/**
 * @hidden 
 * <p>It represents a pointer to the component's instance</p>
 * @type {?}
 */
CfCoreComponent.prototype.nativeElement;
/**
 * @hidden 
 * <p>It represents component tooltip</p>
 * @type {?}
 */
CfCoreComponent.prototype.tooltip;
/**
 * <p>It enables component internationalization</p>
 * @type {?}
 */
CfCoreComponent.prototype.enabledI18N;
/**
 * <p>It enables component drag and drop</p>
 * @type {?}
 */
CfCoreComponent.prototype.draggable;
/**
 * @hidden 
 * <p>It is a dynamic class the user can pass for the internal button</p>
 * @type {?}
 */
CfCoreComponent.prototype.cfClass;
/**
 * <p>It represents core component notifications property object based on NotificationModel Class</p>
 * @type {?}
 */
CfCoreComponent.prototype.notification;
/**
 * <p> It represents the user defined template passed to the component
 * @type {?}
 */
CfCoreComponent.prototype.compTemplate;
/**
 * @hidden
 * @type {?}
 */
CfCoreComponent.prototype.activeTemplate;
/**
 * <p>It is core component Notifications events emmiter to be used by other components</p>
 * @type {?}
 */
CfCoreComponent.prototype.notificationAction;
/**
 * @hidden 
 * <p> Saves the tags of the events that the component is subscribed for.</p>
 * <p> Example: weather1, weather2, clock1...</p>
 * @type {?}
 */
CfCoreComponent.prototype.subscriptionTags;
/**
 * @hidden 
 * <p>Identifier when all component properties are ready to be rendered in html</p>
 * @type {?}
 */
CfCoreComponent.prototype._inited;
/** @type {?} */
CfCoreComponent.prototype.elementRef;
/** @type {?} */
CfCoreComponent.prototype.templateService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
